function sleep(ms) { 
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Export data to specified format
 * @param app - qlik app
 * @param id - qlik object id
 * @param format - OOXML, CSV_C, CSV_T see more docs
 * @param state - "A" (all values), "P" (possible values)
 */
/**
 * Export data to specified format
 * @param app - qlik app
 * @param id - qlik object id
 * @param format - OOXML, CSV_C, CSV_T see more docs
 * @param state - "A" (all values), "P" (possible values)
 */
export async function ExportData({ app, id, format = "OOXML", state = "P"
  , onExportStart = null, onExportFinish=null }) {
  const exportType = "data";
  let vis = await app.visualization.get(id);
  if(vis.model && 
    vis.model.layout &&
    vis.model.layout.qInfo &&
    vis.model.layout.qInfo.qType === 'container') {
    const activeTab = vis.model.layout.activeTab; // is actual object id
    vis = await app.visualization.get(activeTab);
  }
  if(onExportStart)
    await onExportStart({ vis, exportType });

  vis.exportData({ format, state }).then(async function (link) {
    try {
      if(onExportFinish)
        await onExportFinish({ vis, link, error: null, exportType });
      else
        window.open(link, "_blank");
    } finally {
      vis.close();
    }
  }).catch(function (error) {
    vis && vis.close();
    onExportFinish && onExportFinish({ vis: null, link: null, error, exportType });
  });
  //});
}

/**
 * Export image
 * @param app - qlik app
 * @param id - qlik object id
 * @param width - width in pixels
 * @param height - height in pixels
 * @param format - png, jpg
 */
export function ExportImg({ app, id, width = 1920, height = 1080, format = "jpg",
  onExportStart = null, onExportFinish=null }) {
  const exportType = "image";
  app.visualization.get(id).then(async function (vis) {
    const settings = { format, height, width };
    if(onExportStart) 
      await onExportStart({ vis, settings, exportType });

    vis.exportImg(settings).then(async function (link) {
      try {
        if(onExportFinish)
          await onExportFinish({ vis, link, error: null, exportType });
        else
          window.open(link, "_blank");
      } finally {
        vis.close();
      }
    }).catch(function (error) {
      onExportFinish && onExportFinish({ vis: null, link: null, error, exportType });
      vis && vis.close();
    });
  });
}

/**
 * Export PDF
 * @param app - qlik app
 * @param id - qlik object id
 * @param documentSize - Page size of the output PDF: a3, a4, a5, a6, a7
 * @param orientation - portrait, landscape
 * @param aspectRatio - 0, 2
 */
export function ExportPdf({ app, id, documentSize = 'a4',
  orientation = 'landscape', aspectRatio = 2,
  onExportStart = null, onExportFinish=null }) {
  const exportType = "pdf";
  app.visualization.get(id).then(async function (vis) {
    const settings = { documentSize, orientation, aspectRatio };
    if(onExportStart) 
      await onExportStart({ vis, settings, exportType });

    vis.exportPdf(settings).then(async function (link) {
      try {
        if(onExportFinish)
          await onExportFinish({ vis, link, error: null, exportType });
        else
          window.open(link, "_blank");
      } finally {
        vis.close();
      }
    }).catch(function (error) {
      vis && vis.close();
      onExportFinish && onExportFinish({ vis: null, link: null, error, exportType });
    });
  });
}

export function ApplyBookmark(app, id) {
  return app.bookmark.apply(id);
}

// To fix issue when bookmark created it can be published after some time
let justCreated = {};
const bmTimeoutMs = process.env.REACT_APP_AUTOSAVE_TIMEOUT_MS || 30000;
function setJustCreated(bid) {
  justCreated[bid] = setTimeout(() => clearJustCreated(bid), bmTimeoutMs);
}

function clearJustCreated(bid) {  
  delete justCreated[bid];
}

function isJustCreated(bid) {
  return justCreated[bid];
}

export async function CreateBookmark(app, title, description, sheetId) {
  const b = await app.model.enigmaModel.createBookmark(
    {
      qInfo: {
        qType: "bookmark"
      },
      qMetaDef: {
        title,
        description,
        isExtended: true,
      },
      qIncludeVariables: true,
      page: sheetId ? sheetId : '/',
    },
    []
  );

  await b.publish(); // to force engine call savePropertiesCaches to store data in db using qrs
  await b.unPublish();
  return b;
}

export function GetBookmark(app, id) {
  return app.model.enigmaModel.getBookmark(id);
}

export function RemoveBookmark(app, id) {
  return app.bookmark.remove(id);
}

function GetFullUserId(user) {
  return user ? `${user.UserDirectory}/${user.getFullUserId()}` : '';
}

export async function PublishBookmark(app, id, user) {
  // reload !
  if(isJustCreated(id))
    await sleep(bmTimeoutMs);

  let b = await app.model.enigmaModel.getBookmark(id);

  const userId = GetFullUserId(user);
  const props = await b.getProperties();
  props.qInfo.qType = `bookmark/${userId}`; // Makes published bookmark invisible to other users
  await b.setProperties(props);
  await b.publish();
}

export async function UnpublishBookmark(app, id) {
  const b = await app.model.enigmaModel.getBookmark(id);
  await b.unPublish();

  const props = await b.getProperties();
  props.qInfo.qType = 'bookmark';
  await b.setProperties(props);  
}

export async function GetBookmarks(app, user) {
    await app.model.waitForOpen.promise;
    const em = app.model.enigmaModel;
    const userId = GetFullUserId(user);
    if (em.session?.config?.protocol) {
      em.session.config.protocol.delta = false;
    }
    app.model.enigmaModel.session.config.protocol.delta = false;
    const bookmarks = await em.getBookmarks({
     qOptions: {
       qTypes: [
         'bookmark', `bookmark/${userId}` // bookmark's types to load
       ],
       qData: {
        creationDate: "/creationDate",
       },
       qIncludePatches: false,
     }});

    if (em.session?.config?.protocol) {
      em.session.config.protocol.delta = true;
    }
    //  return bookmarks;
    return bookmarks.filter(b => {
      return b.qMeta.approved 
      || (b.qMeta.owner.userDirectory === user.UserDirectory 
        && b.qMeta.owner.userId === user.getFullUserId())
      });
}